import { useContext, useEffect } from 'react';

import { loadBraze, setBrazeUser } from 'app/shared/utils/braze';
import { useCookiebotConsent } from 'app/shared/utils/useCookiebotConsent';
import { AuthContext } from 'app/shared/context/Auth';

// For pages that use Braze's in-browser features (e.g. in-app messages), via
// withBraze. Events reach Braze through Segment, so nothing here logs events.
// Braze keeps running after the visitor leaves the page; stopping it on
// consent withdrawal and resetting it on logout happen on every page, in
// AnalyticsProvider.
export const useBraze = () => {
  const { consentReady, marketingConsent } = useCookiebotConsent();
  const { user, loggedIn, loading } = useContext(AuthContext);

  // Not user.id: Braze advises against guessable IDs, and Segment maps
  // braze_external_id to the Braze profile, so both need the same ID
  const brazeExternalId = loggedIn ? user?.brazeExternalId : undefined;

  useEffect(() => {
    // Waiting for the logged-in user to load lets loadBraze set the Braze
    // user before it opens a Braze session
    if (consentReady && marketingConsent && !loading) {
      loadBraze(brazeExternalId);
    }
  }, [consentReady, marketingConsent, loading]);

  useEffect(() => {
    if (brazeExternalId) {
      setBrazeUser(brazeExternalId);
    }
  }, [brazeExternalId]);
};
